import React, {FC} from 'react';

import {ReactComponent as Arrow} from '../../assets/arrow.svg';
import {ReactComponent as MapMarker} from '../../assets/map-marker.svg';
import dayjs from 'dayjs';
import {GeoLocation} from '../../services/api/models/GeoLocation';
import {DataTextBody} from '../data-text-body/data-text-body.component';

type Props = {
  location: GeoLocation;
  onSelect(): void;
};

export const LocationHistoryListItem: FC<Props> = ({location, onSelect}) => (
  <div className="flex flex-row border-b border-b-gray-300 py-2 items-center">
    <div className="rounded-md border-gray-300 border mx-2 flex items-center justify-center max-w-40 md:max-w-80 py-2" style={{maxHeight:50, maxWidth:50}}>
      <MapMarker height={30} />
    </div>
    <div className="flex flex-1 flex-col justify-center pt-1">
      <h5 className="fontBook">{dayjs(location.eventDate).format('DD/MM/YYYY | HH:mm:ss')}</h5>
      <DataTextBody>{location.address}</DataTextBody>
    </div>
    <button className="w-1/6 flex items-center justify-center" style={{maxWidth: 80}} onMouseDown={onSelect}>
      <Arrow />
    </button>
  </div>
);
